import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CreateIcon from '@material-ui/icons/Create';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import ShowFiles from '../updateGrRecord/ShowFiles';
import DropFilesAttach from './files/DropFilesAttach';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function OtherInfo(props) {
  const classes = useStyles();
  const { handleOpenDialog, POBatchRecordDetails, isAddRecord } = props;
  const { otherInformationRemarks } = props.POBatchRecordDetails;
  const [otherFiles, setOtherFiles] = React.useState(
    POBatchRecordDetails.otherFiles
  );

  const fileHandling = (files) => {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => console.error('file reading was aborted');
      reader.onerror = () => console.error('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: file.name,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };

        props.handlingFiles(newArr, 'otherFiles');
      };
    });
  };

  const handlingDeleteFile = (i) => {
    // for rec fromBE=> mfd as 1, for local filter out
    //check for filetype in file
    //if 'buffer' then follow filter logic
    // if it is not buffer edit that file data sayn mfd 1
    if (otherFiles[i].grFileType === 'buffer') {
      let newdel = otherFiles.filter(
        (file) => file.grFileName !== otherFiles[i].grFileName
      );
      setOtherFiles(newdel);
    } else {
      // otherFiles[i].markForDelete=1;
      let markDelFile = otherFiles.map((file) =>
        file.grFileHash === otherFiles[i].grFileHash
          ? { ...file, markForDelete: true }
          : file
      );
      setOtherFiles(markDelFile);
    }
  };
  return (
    <React.Fragment>
      <Grid container className={classes.child}>
        <Grid item xs={8} sm={6} md={6} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Other Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        {localStorage.getItem('collabType') !== 'Pharma Co' &&
        props.status !== 3 ? (
          props.isEditExist && (
            <Grid item xs={4} sm={6} md={6} className={classes.button}>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                onClick={() => handleOpenDialog('openOtherInfo')}
              >
                Edit
              </Button>
            </Grid>
          )
        ) : (
          <Grid item xs={4} sm={6} md={6}></Grid>
        )}

        <Grid item xs={12} sm={12} md={12} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Additional Remarks (optional)
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {otherInformationRemarks === ''
              ? '-Not Provided-'
              : otherInformationRemarks}
          </Typography>
        </Grid>

        {localStorage.collabType === 'CMO' && props.status === 3 && (
          <Grid container justify='center' style={{ paddingBottom: '2rem' }}>
            <Grid item xs={12} sm={12} md={12}>
              <DropFilesAttach
                title='Additional File(s) (optional)'
                handleUploadFiles={fileHandling}
              />
            </Grid>
          </Grid>
        )}

        {!isAddRecord && (
          <Grid container className={classes.padding}>
            <Grid item xs={12} sm={6} md={6} style={{ paddingBottom: '1rem' }}>
              <Typography
                variant='body2'
                className={classes.font}
                style={{ paddingBottom: '0.5rem' }}
              >
                Uploaded Document List
              </Typography>

              <ShowFiles
                files={POBatchRecordDetails.otherFiles}
                handlingDeleteFile={props.parentHandlingDeleteFile}
                name='otherFiles'
                isUploadFile={
                  props.status === 3 &&
                  localStorage.collabType === 'CMO' &&
                  true
                }
              />
            </Grid>
          </Grid>
        )}

        {isAddRecord && (
          <Grid container className={classes.padding}>
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant='body2' className={classes.font}>
                Uploaded Document List
              </Typography>
              {otherFiles === undefined || otherFiles.length === 0 ? (
                <Typography variant='body2' className={classes.document}>
                  -No Documents Uploaded-
                </Typography>
              ) : (
                <Typography variant='body2'>
                  {otherFiles.length !== 0
                    ? otherFiles.map((file, i) => {
                        return (
                          <span
                            key={i}
                            className={classes.closeText}
                            style={{ paddingBottom: '0.5rem' }}
                          >
                            {file.markForDelete === true ||
                            file.markForDelete === 1
                              ? null
                              : file.grFileName}

                            {/* {file.grFileName}{' '} */}
                            {localStorage.collabType === 'CMO' ? (
                              <CloseIcon
                                fontSize='small'
                                color='error'
                                style={{ paddingLeft: '0.5rem' }}
                                onClick={() => handlingDeleteFile(i)}
                              />
                            ) : null}
                            <br />
                          </span>
                        );
                      })
                    : ''}
                </Typography>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
}
